/**
 * GitHub Onboarding Order Status Configuration
 *
 * Short Form Reference:
 * - MGR = Business Application Owner (Application Owner)
 * - GO = Requestor Manager (Active Directory Group Owner)
 * - GH = GitHub AD Group Owner (ADO Owner)
 *
 * Status Format:
 * - Single rejection: 'ROLE:Rejected'
 * - Multiple rejections: 'ROLE1-ROLE2:Rejected'
 * - With pending: 'ROLE1-ROLE2:Rejected|ROLE3:Pending'
 *
 * Examples:
 * - 'MGR:Rejected' = Manager Rejected
 * - 'GO-GH:Rejected' = Requestor Manager and GitHub AD Group Owner Both Rejected
 * - 'MGR-GO:Rejected|GH:Pending' = Manager and Requestor Manager Rejected, GitHub AD Group Owner Pending
 */
import { orderStatus } from 'utils/orderStatus';

export default {
    [orderStatus[0]?.name]: [
        { name: 'Requested', status: 'done' },
        { name: 'Provisioning', status: 'wait' },
        { name: orderStatus[4]?.name, status: 'wait' },
    ],

    'PA-All Pending': [
        { name: 'Business Application Owner', status: 'hourglass' },
        { name: 'Requestor Manager', status: 'hourglass' },
        { name: 'GitHub AD Group Owner', status: 'hourglass' },
    ],

    'PA-MGR:Approved': [
        { name: 'Business Application Owner', status: 'done' },
        { name: 'Requestor Manager', status: 'hourglass' },
        { name: 'GitHub AD Group Owner', status: 'hourglass' },
    ],

    'PA-GO:Approved': [
        { name: 'Business Application Owner', status: 'done' },
        { name: 'Requestor Manager', status: 'done' },
        { name: 'GitHub AD Group Owner', status: 'hourglass' },
    ],

    'PA-GH:Approved': [
        { name: 'Business Application Owner', status: 'done' },
        { name: 'Requestor Manager', status: 'done' },
        { name: 'GitHub AD Group Owner', status: 'done' },
    ],

    'PA-Only-MGR': [{ name: 'Business Application Owner', status: 'hourglass' }],

    'PA-Only-GH': [
        { name: 'GitHub AD Group Owner', status: 'done' },
        { name: 'Business Application Owner', status: 'hourglass' },
        { name: 'Requestor Manager', status: 'hourglass' },
    ],

    'PA-Only-GO': [
        { name: 'Requestor Manager', status: 'done' },
        { name: 'Business Application Owner', status: 'hourglass' },
        { name: 'GitHub AD Group Owner', status: 'hourglass' },
    ],

    [orderStatus[1]?.name]: [
        { name: 'Requested', status: 'done' },
        { name: 'Business Application Owner', status: 'done' },
        { name: 'Requestor Manager', status: 'done' },
        { name: 'GitHub AD Group Owner', status: 'done' },
        { name: 'Provisioning', status: 'hourglass' },
        { name: orderStatus[4]?.name, status: 'wait' },
    ],

    [orderStatus[2]?.name]: [
        { name: 'Requested', status: 'done' },
        { name: 'Cancelled', status: 'clear' },
    ],

    [orderStatus[3]?.name]: [
        { name: 'Requested', status: 'done' },
        { name: 'Business Application Owner', status: 'clear' },
        { name: 'Requestor Manager', status: 'wait' },
        { name: 'GitHub AD Group Owner', status: 'wait' },
        { name: 'Provisioning', status: 'wait' },
    ],

    'MGR:Rejected': [
        { name: 'Requested', status: 'done' },
        { name: 'Business Application Owner', status: 'clear' },
        { name: 'Requestor Manager', status: 'done' },
        { name: 'GitHub AD Group Owner', status: 'done' },
        { name: 'Provisioning', status: 'wait' },
    ],

    'MGR:Rejected|Others:Pending': [
        { name: 'Requested', status: 'done' },
        { name: 'Business Application Owner', status: 'clear' },
        { name: 'Requestor Manager', status: 'hourglass' },
        { name: 'GitHub AD Group Owner', status: 'hourglass' },
        { name: 'Provisioning', status: 'wait' },
    ],

    'GO:Rejected': [
        { name: 'Requested', status: 'done' },
        { name: 'Business Application Owner', status: 'done' },
        { name: 'Requestor Manager', status: 'clear' },
        { name: 'GitHub AD Group Owner', status: 'done' },
        { name: 'Provisioning', status: 'wait' },
    ],

    'GO:Rejected|Others:Pending': [
        { name: 'Requested', status: 'done' },
        { name: 'Business Application Owner', status: 'hourglass' },
        { name: 'Requestor Manager', status: 'clear' },
        { name: 'GitHub AD Group Owner', status: 'hourglass' },
        { name: 'Provisioning', status: 'wait' },
    ],

    'GH:Rejected': [
        { name: 'Requested', status: 'done' },
        { name: 'Business Application Owner', status: 'done' },
        { name: 'Requestor Manager', status: 'done' },
        { name: 'GitHub AD Group Owner', status: 'clear' },
        { name: 'Provisioning', status: 'wait' },
    ],

    'GH:Rejected|Others:Pending': [
        { name: 'Requested', status: 'done' },
        { name: 'Business Application Owner', status: 'hourglass' },
        { name: 'Requestor Manager', status: 'hourglass' },
        { name: 'GitHub AD Group Owner', status: 'clear' },
        { name: 'Provisioning', status: 'wait' },
    ],

    'GH:Rejected|MGR:Pending': [
        { name: 'Requested', status: 'done' },
        { name: 'Business Application Owner', status: 'hourglass' },
        { name: 'Requestor Manager', status: 'done' },
        { name: 'GitHub AD Group Owner', status: 'clear' },
        { name: 'Provisioning', status: 'wait' },
    ],

    'GH:Rejected|GO:Pending': [
        { name: 'Requested', status: 'done' },
        { name: 'Business Application Owner', status: 'done' },
        { name: 'Requestor Manager', status: 'hourglass' },
        { name: 'GitHub AD Group Owner', status: 'clear' },
        { name: 'Provisioning', status: 'wait' },
    ],

    'MGR:Rejected|GO:Pending': [
        { name: 'Requested', status: 'done' },
        { name: 'Business Application Owner', status: 'clear' },
        { name: 'Requestor Manager', status: 'hourglass' },
        { name: 'GitHub AD Group Owner', status: 'done' },
        { name: 'Provisioning', status: 'wait' },
    ],

    'MGR:Rejected|GH:Pending': [
        { name: 'Requested', status: 'done' },
        { name: 'Business Application Owner', status: 'clear' },
        { name: 'Requestor Manager', status: 'done' },
        { name: 'GitHub AD Group Owner', status: 'hourglass' },
        { name: 'Provisioning', status: 'wait' },
    ],

    'GO:Rejected|MGR:Pending': [
        { name: 'Requested', status: 'done' },
        { name: 'Business Application Owner', status: 'hourglass' },
        { name: 'Requestor Manager', status: 'clear' },
        { name: 'GitHub AD Group Owner', status: 'done' },
        { name: 'Provisioning', status: 'wait' },
    ],

    'GO:Rejected|GH:Pending': [
        { name: 'Requested', status: 'done' },
        { name: 'Business Application Owner', status: 'done' },
        { name: 'Requestor Manager', status: 'clear' },
        { name: 'GitHub AD Group Owner', status: 'hourglass' },
        { name: 'Provisioning', status: 'wait' },
    ],

    'GO-GH:Rejected': [
        { name: 'Requested', status: 'done' },
        { name: 'Business Application Owner', status: 'done' },
        { name: 'Requestor Manager', status: 'clear' },
        // { name: 'GitHub AD Group Owner', status: 'clear' },
        { name: 'Provisioning', status: 'wait' },
    ],

    'GO-GH:Rejected|MGR:Pending': [
        { name: 'Requested', status: 'done' },
        { name: 'Business Application Owner', status: 'hourglass' },
        { name: 'Requestor Manager', status: 'clear' },
        // { name: 'GitHub AD Group Owner', status: 'clear' },
        { name: 'Provisioning', status: 'wait' },
    ],

    'MGR-GH:Rejected': [
        { name: 'Requested', status: 'done' },
        { name: 'Business Application Owner', status: 'clear' },
        { name: 'Requestor Manager', status: 'done' },
        // { name: 'GitHub AD Group Owner', status: 'clear' },
        { name: 'Provisioning', status: 'wait' },
    ],

    'MGR-GH:Rejected|GO:Pending': [
        { name: 'Requested', status: 'done' },
        { name: 'Business Application Owner', status: 'clear' },
        { name: 'Requestor Manager', status: 'hourglass' },
        // { name: 'GitHub AD Group Owner', status: 'clear' },
        { name: 'Provisioning', status: 'wait' },
    ],

    'MGR-GO:Rejected': [
        { name: 'Requested', status: 'done' },
        { name: 'Business Application Owner', status: 'clear' },
        // { name: 'Requestor Manager', status: 'clear' },
        { name: 'GitHub AD Group Owner', status: 'done' },
        { name: 'Provisioning', status: 'wait' },
    ],

    'MGR-GO:Rejected|GH:Pending': [
        { name: 'Requested', status: 'done' },
        { name: 'Business Application Owner', status: 'clear' },
        // { name: 'Requestor Manager', status: 'clear' },
        { name: 'GitHub AD Group Owner', status: 'hourglass' },
        { name: 'Provisioning', status: 'wait' },
    ],

    'PA-All Rejected': [
        { name: 'Requested', status: 'done' },
        { name: 'Business Application Owner', status: 'clear' },
        // { name: 'Requestor Manager', status: 'clear' },
        // { name: 'GitHub AD Group Owner', status: 'clear' },
        { name: 'Provisioning', status: 'wait' },
    ],

    [orderStatus[4]?.name]: [
        { name: 'Requested', status: 'done' },
        { name: 'Business Application Owner', status: 'done' },
        { name: 'Requestor Manager', status: 'done' },
        { name: 'GitHub AD Group Owner', status: 'done' },
        { name: 'Provisioning', status: 'done' },
        { name: 'Completed', status: 'done' },
    ],

    [orderStatus[5]?.name]: [
        { name: 'Requested', status: 'done' },
        { name: 'Action Required', status: 'priority-high' },
        { name: 'Business Application Owner', status: 'wait' },
        { name: 'Requestor Manager', status: 'wait' },
        { name: 'GitHub AD Group Owner', status: 'wait' },
        { name: 'Provisioning', status: 'wait' },
        { name: 'Completed', status: 'wait' },
    ],

    [orderStatus[6]?.name]: [
        { name: 'Requested', status: 'done' },
        { name: 'Business Application Owner', status: 'done' },
        { name: 'Requestor Manager', status: 'done' },
        { name: 'GitHub AD Group Owner', status: 'done' },
        { name: 'Provisioning', status: 'done' },
        { name: orderStatus[4]?.name, status: 'hourglass' },
    ],
};
